const hex = (x) => {
  x = x.toString(16);
  return (x.length == 1) ? '0' + x : x;
}

const getColorInBetween = (cmax, cmin, ratio) => {
  let color1 = cmax.replace("#", "")
  let color2 = cmin.replace("#", "")
  const r = Math.ceil(parseInt(color1.substring(0,2), 16) * ratio + parseInt(color2.substring(0,2), 16) * (1-ratio));
  const g = Math.ceil(parseInt(color1.substring(2,4), 16) * ratio + parseInt(color2.substring(2,4), 16) * (1-ratio));
  const b = Math.ceil(parseInt(color1.substring(4,6), 16) * ratio + parseInt(color2.substring(4,6), 16) * (1-ratio));
  return ("#" + hex(r) + hex(g) + hex(b))
}

function getColor(val, sensor){
  let colorArray
  if(sensor){
    colorArray = sensor.colorArray
    if(sensor.reverse){
      colorArray = Array.from(sensor.colorArray).reverse()
    }
  } else {
    colorArray = ["#FFBF00", "#FF0000"]
  }
  if(sensor?.ranges?.length > 0) {
    if(val <= sensor?.ranges[0]?.min){
      return colorArray[0]
    }
    if(val >= sensor?.ranges[sensor.ranges.length - 1]?.max){
      return colorArray[sensor.ranges.length - 1]
    }
    for(let i=0; i<sensor.ranges.length-1; i++){
      if(val >= sensor.ranges[i].min && val < sensor.ranges[i+1].max){
        // let amount = (0.5 - (target.dataItem.get("value") - found.ranges[i].min) / (found.ranges[i].max - found.ranges[i].min))/2 
        // return am5.color(shade(colorArray[i], amount))

        let ratio = (val - sensor.ranges[i].min) / (sensor.ranges[i+1].max - sensor.ranges[i].min)
        return getColorInBetween(colorArray[i+1], colorArray[i], ratio)
      }
    }
  }else {
      let min = sensor?.min || 0
      let max = sensor?.max || 100
      const increments = (max-min)/(colorArray.length-1)
      if(val >= max){
        return colorArray[colorArray.length-1]
      }
      if(val <= min){
        return colorArray[0]
      }
      for(let i=0; i<colorArray.length-1; i++){
        if(val >= min + i*increments && val < min + (i+2)*increments){
          let ratio = ((val - (min + (i)*increments)) / (2*increments))
          return getColorInBetween(colorArray[i+1], colorArray[i], ratio)
        } 
      }
    }
}


// function getColor(val, sensor) {
//   const colorfound = sensor
//   let code = [...sensor.colorArray];
//   let res;
//   if (sensor?.ranges && sensor?.ranges.length) {
//     let index = 0;
//     for (const range of sensor?.ranges) {
//       let min = parseInt(range.min);

//       let max = parseInt(range.max);
//       if (index == 0 && val < min) {
//         res = code[0];
//         break;
//       }

//       if (
//         val >= min &&
//         (index == sensor?.ranges.length - 1
//           ? val <= max
//           : val < parseInt(sensor?.ranges[index + 1].min))
//       ) {
//         res = code[index];
//         break;
//       }
//       if (index == sensor?.ranges.length - 1 && val > max) {
//         res = code[index];
//         break;
//       }
//       index += 1;
//     }
//   } else {
//     if (sensor?.reverse) code.reverse();
//     let perc = ((sensor.min - val) / (sensor.min - sensor.max)) * 100;
//     if (perc > 100) perc = 100;
//     if (perc < 0) perc = 0;
//     let range = Math.round(100 / code.length);
//     let index = Math.trunc(perc / range);
//     index = index >= code.length ? index - 1 : index;
//     res = code[index];
//   }
//   return res;
// }

function generateBackground(colorArray, reverse) {
  let res;
  let code = [...colorArray];
  if (reverse) code.reverse();
  res = `linear-gradient(to right,${code.join(", ")})`;
  return res;
}

export { getColor, generateBackground };
